import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const pageStyle = {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    background: 'linear-gradient(135deg, #eef2f7, #dce6f5)',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: '2rem'
  };

  const containerStyle = {
    background: '#ffffff',
    padding: '3rem 2rem',
    borderRadius: '16px',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)',
    maxWidth: '500px',
    width: '100%',
    opacity: 0,
    transform: 'translateY(20px)',
    animation: 'fadeInUp 1s ease forwards'
  };

  const h1Style = {
    fontSize: '5rem',
    fontWeight: 700,
    color: '#001f3f',
    marginBottom: '1rem'
  };

  const h2Style = {
    fontSize: '1.8rem',
    color: '#003366',
    marginBottom: '1rem'
  };

  const pStyle = {
    fontSize: '1rem',
    color: '#444',
    marginBottom: '2rem',
    lineHeight: 1.5
  };

  const buttonStyle = {
    background: 'linear-gradient(135deg, #003366, #00509e)',
    color: '#fff',
    fontSize: '1rem',
    padding: '0.9rem 2rem',
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    fontWeight: 600,
    transition: 'all 0.3s ease'
  };

  const buttonHoverStyle = {
    background: 'linear-gradient(135deg, #004080, #0066cc)',
    transform: 'scale(1.05)',
    boxShadow: '0 6px 16px rgba(0,0,0,0.2)'
  };

  return (
    <div style={pageStyle}>
      <Helmet>
        <title>404 Page Not Found | SamSoftix</title>
        <meta
          name="description"
          content="Oops! The page you are looking for does not exist. Visit SamSoftix for software development, IT services, and tech solutions in Sambrial, Pakistan."
        />
        <meta
          name="keywords"
          content="404 page, SamSoftix, software company Pakistan, IT services Sambrial, web development, mobile app development, IT solutions"
        />
        <link rel="canonical" href="https://www.samsoftix.com/404" />
      </Helmet>

      <div style={containerStyle}>
        <h1 style={h1Style}>404</h1>
        <h2 style={h2Style}>Oops! Page Not Found</h2>
        <p style={pStyle}>The page you are looking for does not exist or has been moved.</p>
        <button
          style={buttonStyle}
          onMouseOver={(e) => Object.assign(e.target.style, buttonHoverStyle)}
          onMouseOut={(e) => Object.assign(e.target.style, buttonStyle)}
          onClick={handleGoHome}
        >
          Go to Home
        </button>
      </div>

      {/* Inline Keyframes for fadeInUp */}
      <style>
        {`
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }

          @media (max-width: 480px) {
            div > h1 { font-size: 3.5rem !important; }
            div > h2 { font-size: 1.5rem !important; }
          }
        `}
      </style>
    </div>
  );
};

export default NotFound;
